var map = {
	"./bg1.jpg": 1048,
	"./bg2.jpg": 1049,
	"./bg3.jpg": 1050,
	"./bg4.jpg": 1051,
	"./bg5.jpg": 1052,
	"./bg6.jpg": 1053,
	"./bg7.jpg": 1054
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1901;


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth/img/bg ^\.\/.*$
// module id = 1901
// module chunks = 17